import _ from 'lodash';

// The radio group reads text; an unanswered question (no boolean yet) selects neither option.
export const toYesNoRadioValue = value => (_.isBoolean(value) ? String(value) : '');
